export default __webpack_public_path__ + "static/media/logo.49e4621d.svg";